import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import 'react';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
var variantStyles = variant({
  prop: "variant",
  variants: {
    informational: {
      color: "neutral.0",
      backgroundColor: "secondary.500"
    },
    success: {
      color: "neutral.900",
      backgroundColor: "primary.500"
    },
    warning: {
      color: "neutral.1000",
      backgroundColor: "warning.500"
    },
    error: {
      color: "neutral.0",
      backgroundColor: "danger.500"
    }
  }
});
var Wrapper = styled(Box).withConfig({
  componentId: "qw1lek-0"
})(["display:flex;justify-content:center;align-items:center;min-height:60px;", " ", ";a{color:currentColor;text-decoration:underline;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoint("sm")(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n       justify-content: flex-start;\n    "])));
}, variantStyles);
export { Wrapper };